import React from 'react';
import { useSelector } from 'react-redux';

export default function GraphqlApi() {
  const { GetUser } = useSelector((state) => state.auth);
  return (
    <div className='list-group list-group-checkable'>
      <label className='list-group-item py-3' htmlFor='listGroupCheckableRadios1'>
        <span className='d-block small'>Name : {GetUser.name}</span>
        <span className='d-block small'>Email : {GetUser.email}</span>
        <span className='d-block small'>Mobile Number : {GetUser.phone}</span>
        <span className='d-block small'>Age : {GetUser.age}</span>
        <span className='d-block small'>Gender : {GetUser.gender}</span>
      </label>
    </div>
  );
}
